module.exports = __webpack_public_path__ + "img/more-org-v2.e6fabd21.jpg";